import { useEffect } from 'react';
import CustomModalLayout from './index.layout';

const CustomModal = ({
  title,
  isModalOpen,
  handleModalClose,
  children,
  width = 520,
  contentPadding,
  height,
  fixedHeight,
  isEvents,
  withoutCloseBtn,
  showPrevBtn,
  handlePrevBtn,
  withClosePreview,
  withLabel,
  labelText,
  zIndex = 20,
  fullOverlay = false,
  cannotClose = false,
}) => {
  const closeModalByEsc = (e) => {
    if (e.keyCode === 27 && handleModalClose && !cannotClose) {
      handleModalClose();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', closeModalByEsc);

    return () => {
      window.removeEventListener('keydown', closeModalByEsc);
    };
  }, [isModalOpen]);

  return (
    <CustomModalLayout
      isModalOpen={isModalOpen}
      title={title}
      handleModalClose={handleModalClose}
      width={width}
      height={height}
      contentPadding={contentPadding}
      fixedHeight={fixedHeight}
      isEvents={isEvents}
      withoutCloseBtn={withoutCloseBtn}
      showPrevBtn={showPrevBtn}
      handlePrevBtn={handlePrevBtn}
      withClosePreview={withClosePreview}
      withLabel={withLabel}
      labelText={labelText}
      zIndex={zIndex}
      fullOverlay={fullOverlay}
      cannotClose={cannotClose}
    >
      {children}
    </CustomModalLayout>
  );
};

export default CustomModal;
